import { render, staticRenderFns } from "./ProfileViews.vue?vue&type=template&id=0273f481&"
import script from "./ProfileViews.vue?vue&type=script&lang=js&"
export * from "./ProfileViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports